export default __webpack_public_path__ + "static/media/image (4)@2x.1bf55b46.png";